<template>
  <HelpCenterLayout>
    <Home />
  </HelpCenterLayout>
</template>

<script setup lang="ts">
import HelpCenterLayout from '~/scopes/help-center/layouts/HelpCenterLayout.vue'

import Home from '../components/Home/Home.vue'
</script>
